<template>
  <div style="min-height:100%;background-color:#fff">
    <header>
      <img-v3 v-show="form.pic" :src="form.pic" />
    </header>
    <main>
      <div>{{form.sub_title}}</div>
      <p v-for="c in form.document_list">{{c}}</p>
    </main>
    <footer v-show="form.register_button">
      <p class="reg_btn" @click="go_reg">{{form.register_button}}</p>
      <p class="skip_btn" @click="skip">{{form.skip_button}}</p>
    </footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { showAlertDialog, showLoadingToast, showDialog } from "../../tools/Tip";
import { setTitle } from "../../tools/setTitle";
export default {
  created() {
    this.getPageConfig();
  },
  mounted() {
    Omega.trackEvent("gd_vamosPrepare_view_sw", "", {
      source: this.params.get("vamos_register_source")
    });
    //判断是否进入可fasttrap流程
      let up = new URLSearchParams(window.location.search);
      if (this._ticket) {
          up.set("ticket", this._ticket);
        }
      post(process.env.FASTTRAP_SHOW, up)
          .then(data => {
            if(data.result !== false){
              showDialog(this, {
                type: "confirm",
                title:this.$t(
                    "GRider_Track_minutes_to_dNjh"
                  ).replace(
                    /{{carona_name}}/,
                    this.$t("GRider_Track_Brazilian_Hitch_VklT")
                  ),
              content: this.$t(
                    "GRider_Track_You_are_lqKw"
                  ).replace(
                    /{{pop_name}}/,
                    this.$t("GRider_Track_Brazilian_Express_BxFj")
                  ).replace(
                    /{{carona_name}}/,
                    this.$t("GRider_Track_Brazilian_Hitch_VklT")
                  ),
                confirmBtn: { text: this.$t("GRider_Track_Sync_now_RVJm") },
                cancelBtn: { text: this.$t("GRider_Track_No_thank_HzoZ") },
                onConfirm: () => {this.handleSubmit(data.ticket)}
                // onCancel: () => {
                //   Omega.trackEvent("toggle_CNH_update_popup_no");
                // }
              });
            }
          })
          .catch(err => {
            showAlertDialog(this);
          })
          .finally(() => {
            this.toast.hide();
      });
  },
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapState(["_ticket"]),
    params() {
      return new URLSearchParams(location.search);
    }
  },
  methods: {
    handleSubmit(ticket){
      let up = new URLSearchParams(location.search);
      let vamos_ticket
      if (this._ticket) {
        vamos_ticket = this._ticket
      }else if(up.get("ticket")){
        vamos_ticket = up.get("ticket");
      }else if(up.get("token")){
        vamos_ticket = up.get("token");
      }
      up.set("vamos_ticket", vamos_ticket);
      up.set("ticket", ticket);
      up.set("passengerduan", 'in');
      up.set("vamos_end", "passenger"); // 新增 vamos_end=passenger 表示来自乘客端注册
      location.replace(`https://page.didiglobal.com/driver-page/toVamos/index.html?product=13&${up}#/confirm`)
    },
    go_reg() {
      this.$router.replace({ name: "baseInfoBr" });
      Omega.trackEvent("gd_vamosPrepare_start_btn_ck", "", {
        source: this.params.get("vamos_register_source")
      });
    },
    skip() {
      Omega.trackEvent("gd_vamosPrepare_cancel_btn_ck", "", {
        source: this.params.get("vamos_register_source")
      });
      Fusion.closePage && Fusion.closePage({}, () => {});
    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.PREPARE_INFO, up)
        .then(data => {
          this.form = data.form;
          data.title && setTitle(data.title);
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
        });
    }
  }
};
</script>
<style lang="less" scoped>
header {
  img {
    width: 100%;
  }
}
main,
footer {
  padding: 0 0.36rem;
}
main {
  padding-top: 0.6rem;
  padding-bottom: 2.4rem;
  div {
    margin-bottom: 0.4rem;
    font-size: 0.44rem;
    font-weight: bold;
    color: #000;
  }
  p {
    padding-bottom: 0.3rem;
    font-size: 0.38rem;
    color: #000;
  }
}
footer {
  position: fixed;
  left: 0;
  bottom: 0.65rem;
  width: 100%;
  box-sizing: border-box;
  .reg_btn {
    width: 100%;
    height: 0.92rem;
    margin-bottom: 0.36rem;
    font-size: 0.32rem;
    font-weight: bold;
    line-height: 0.92rem;
    color: #000000;
    text-align: center;
    background-image: linear-gradient(135deg, #fff362 0%, #fd9728 100%);
    border-radius: 0.24rem;
  }
  .skip_btn {
    font-size: 0.28rem;
    line-height: 0.45rem;
    color: #666666;
    text-align: center;
  }
}
</style>
